import { Redirect } from 'react-router-dom';

import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';
import { localizeRoutes } from '../utils/routeUtils';
import LetterDirectoryPage from '../components/pages/directory/LetterDirectoryPage';
import CategoryDirectoryPage from '../components/pages/directory/CategoryDirectoryPage';
import MostPopularDirectoryPage from '../components/pages/directory/MostPopularDirectoryPage';

const cashbackDirectoryLocalizableRoutes = [
    {
        path: PATH.CASHBACK_MOST_POPULAR_PATH,
        exact: true,
        component: MostPopularDirectoryPage
    },
    {
        path: `${PATH.CASHBACK_ALPHA_PATH}:letter`,
        component: LetterDirectoryPage
    },
    {
        path: `${PATH.CASHBACK_CATEGORY_PATH}:categoryName-:categoryId`,
        component: CategoryDirectoryPage
    },
    {
        path: PATH.CASHBACK_PATH,
        exact: true,
        component: Redirect,
        to: PATH.CASHBACK_MOST_POPULAR_PATH
    }
];

export const cashbackDirectoryRoutes = [
    ...cashbackDirectoryLocalizableRoutes,
    ...localizeRoutes(LOCALES, cashbackDirectoryLocalizableRoutes)
];

const reductionDirectoryLocalizableRoutes = [
    {
        path: PATH.REDUCTION_MOST_POPULAR_PATH,
        exact: true,
        component: MostPopularDirectoryPage,
        props: { isCodePromo: true }
    },
    {
        path: `${PATH.REDUCTION_ALPHA_PATH}:letter`,
        component: LetterDirectoryPage,
        props: { isCodePromo: true }
    },
    {
        path: `${PATH.REDUCTION_CATEGORY_PATH}:categoryName-:categoryId`,
        component: CategoryDirectoryPage,
        props: { isCodePromo: true }
    },
    {
        path: PATH.REDUCTION_PATH,
        exact: true,
        component: Redirect,
        to: PATH.REDUCTION_MOST_POPULAR_PATH
    }
];

export const reductionDirectoryRoutes = [
    ...reductionDirectoryLocalizableRoutes,
    ...localizeRoutes(LOCALES, reductionDirectoryLocalizableRoutes)
];

export const directoryRoutes = [...cashbackDirectoryRoutes, ...reductionDirectoryRoutes];



// WEBPACK FOOTER //
// ./src/routes/directory.js